import React from 'react';
import { FormComponent } from 'components';
import icLogo from 'components/ui/static/logo-dark.svg';
import {
  wrap,
  card,
  logo,
  eyebrow,
  title,
  label,
  inpuyStyle,
  submit,
  footer,
} from './style';
import useLogin from './useLogin';

function Login() {
  const { handleSubmit, handleChange, idRef, pwRef, user } = useLogin();

  return (
    <div css={wrap}>
      <div css={card}>
        <img src={icLogo} alt="yvis" css={logo} />
        <p css={eyebrow}>관리자 센터</p>
        <h1 css={title}>
          관리자 계정으로
          <br />
          로그인해 주세요
        </h1>
        <form onSubmit={handleSubmit}>
          <label css={label}>
            <span>아이디</span>
            <FormComponent.Input
              ref={idRef}
              css={inpuyStyle}
              autoComplete="off"
              type="text"
              placeholder="아이디를 입력해주세요"
              name="username"
              value={user.username}
              onChange={handleChange}
              maxLength={16}
            />
          </label>
          <label css={label}>
            <span>비밀번호</span>
            <FormComponent.Input
              ref={pwRef}
              css={[
                inpuyStyle,
                { WebkitTextSecurity: 'disc', textSecurity: 'disc' },
              ]}
              autoComplete="off"
              type="text"
              placeholder="비밀번호를 입력해주세요"
              name="password"
              value={user.password}
              onChange={handleChange}
              maxLength={30}
            />
          </label>
          <button type="submit" css={submit}>
            로그인
          </button>
        </form>
      </div>
      <p css={footer}>관리자 전용 페이지입니다.</p>
    </div>
  );
}

export default Login;
